import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CheckoutCancel() {
    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6">
            <div className="max-w-lg w-full rounded-3xl border border-white/10 bg-surface p-10 text-center">
                <p className="text-xs tracking-[0.3em] uppercase text-rose">Checkout cancelled</p>
                <h1 className="font-serif text-4xl mt-2">No worries.</h1>
                <p className="text-white/65 mt-3">You weren't charged. Pick a plan whenever you're ready.</p>
                <Link
                    to="/portal/subscription"
                    data-testid="cancel-back-btn"
                    className="inline-flex items-center gap-2 mt-8 px-7 py-3 rounded-full bg-rose text-ink hover:bg-roseHover transition font-medium"
                >
                    <ArrowLeft className="w-4 h-4" /> Back to plans
                </Link>
            </div>
        </div>
    );
}
